/** A row of the `withdrawals` table as returned by /api/ccpayment/withdraw/list. */
export interface CcWithdrawRow {
  id: number;
  uid: number;
  date: string | null;
  amount: number;
  wallet: string;
  /** 'In Queue' | 'Processing' | 'Success' | 'Failed' | 'Rejected' — older rows may hold a raw txid. */
  status: string;
  coin: string;
  chain: string | null;
  order_id: string | null;
  record_id: string | null;
  txid: string | null;
  approved_by: number | null;
  approved_at: string | null;
  reason: string | null;
  refunded: boolean;
  username: string | null;
  useremail: string | null;
  /** Branch the requesting player belongs to — its agents can handle this request too. */
  branch_name: string | null;
  /** Staff member (admin OR branch agent) who approved/rejected it. */
  action_by: string | null;
}

/** One withdrawable network for a coin, straight from CCPayment's coin list. */
export interface CcNetwork {
  chain: string;
  chainFullName: string;
  contract: string | null;
  isSupportMemo: boolean;
  canWithdraw: boolean;
}

export const STATUS_COLOR: Record<string, string> = {
  'In Queue': '#FFC23F',
  Pending: '#FFC23F',
  Processing: '#5581F7',
  Success: '#0ECC68',
  Failed: '#E01B4F',
  Rejected: '#8384A5',
};

export const cardSx = { bgcolor: '#0E1831', border: '1px solid #1E2D55', borderRadius: 2 };

export const inputSx = {
  '& .MuiOutlinedInput-root': {
    bgcolor: '#10182E',
    '& fieldset': { borderColor: '#1E2D55' },
    '&:hover fieldset': { borderColor: '#2B6EF5' },
    '&.Mui-focused fieldset': { borderColor: '#2B6EF5' },
  },
  '& input': { color: '#F9F9F9' },
  '& .MuiInputLabel-root': { color: '#8384A5' },
  '& .MuiInputLabel-root.Mui-focused': { color: '#2B6EF5' },
  '& .MuiSelect-select': { color: '#F9F9F9' },
};

export const cellSx = { color: '#F9F9F9', borderColor: '#1E2D55', fontSize: '0.8rem' };
export const headSx = { color: '#8384A5', borderColor: '#1E2D55', fontSize: '0.75rem', fontWeight: 700 };
